module.exports = __webpack_public_path__ + "img/pendings.d0f4ab16.png";